import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectSelectedMenu,
  selectUIStates,
  setEditingCollection,
} from "../../redux/features/appData";
import { useAuth } from "../../hooks/useAuth";
import "./CollectionsHeader.css";
import "../../css/Icons.css";
import { GlobalSearch } from "../search/GlobalSearch";
import { MENUS } from "../config/menus";
import { useNavigate } from "react-router-dom";

const SHOW_HEADER = false;

export const CollectionsHeader = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedMenu = useSelector(selectSelectedMenu);
  const uiStates = useSelector(selectUIStates);

  const currentMenu = useRef(selectedMenu);
  const currentUIStates = useRef(uiStates);

  useEffect(() => {
    auth.checkStatus();
    window.addEventListener("keydown", eventKeyDown);

    return () => {
      window.removeEventListener("keydown", eventKeyDown);
    };
  }, []);

  useEffect(() => {
    currentMenu.current = selectedMenu;
  }, [selectedMenu]);

  useEffect(() => {
    currentUIStates.current = { ...uiStates };
  }, [uiStates]);

  const eventKeyDown = (e: any) => {
    // console.log("[eventKeyDown] key: " + e.key);

    const metaKey = e.metaKey;
  };

  // console.log("[CollectionsHeader] dropLinkRecordIds: ", dropLinkRecordIds);

  return (
    <>
      {SHOW_HEADER && (
        <div className="collections-header-container">
          <div className="collections-header-search">
            <GlobalSearch />
          </div>

          <div className="collections-header-right">
            <button
              className="collections-button"
              onClick={() => {
                dispatch(setEditingCollection(null));
                navigate("/create");
              }}>
              New Collection
            </button>
          </div>
        </div>
      )}
    </>
  );
};
